export const checkIsFreeBus = (masterBookId) => {
  /*
  5:バス無料チケット
  701, 702:湘南T-SITE バス無料チケット
  */
  const freeBusIds = [5, 701, 702];
  return freeBusIds.includes(masterBookId);
};
